<template>
  <form :data-vv-scope="fieldData.name">
    <div :class="['form-group', {['has-error']: errors.first(field.name + '-source-form-id', fieldData.name)}]">
      <label :for="field.name + '-source-form-id'">Source form name*</label>
      <select :id="field.name + '-source-form-id'"
              class="form-control"
              v-model="field.formId"
              @change="updateFormFields"
              :data-vv-name="fieldData.name + '-source-form-id'"
              v-validate="'required'">
        <option :value="null">Select...</option>
        <option v-for="form in forms" :value="form.id" v-if="form.id !== formId">{{ form.name }}</option>
      </select>
    </div>

    <div class="row" v-show="isSourceFormRangeSelectVisible">
      <div
        :class="{'col-lg-6' : field.formData == 'daterange', 'col-lg-12' : field.formData != 'daterange'}">
        <div :class="['form-group', {['has-error']: errors.first(field.name + '-source-form-data', fieldData.name)}]">
          <label>Source forms range*</label>
          <select :id="field.name + '-source-form-data'"
                  v-model="field.formData"
                  class="form-control"
                  :data-vv-name="fieldData.name + '-source-form-data'"
                  v-validate="'required'">
            <option :value="'all'">All filled forms</option>
            <option :value="'last'">Most recent entry</option>
            <option :value="'daterange'">Completed At Date range</option>
            <option :value="'daterange-field'">Field Date range</option>
          </select>
        </div>
      </div>

      <div class="col-lg-6 margin-bottom-15" v-if="field.formData == 'daterange-field'">
        <div :class="['form-group', {['has-error']: errors.first(field.name + '-daterange-field', fieldData.name)}]">
          <label :for="field.name + '-daterange-field'">Date field*</label>
          <select :id="field.name + '-daterange-field'"
                  class="form-control"
                  v-model="field.dateRangeField"
                  :data-vv-name="fieldData.name + '-daterange-field'"
                  v-validate="'required'">
            <option :value="null">Select...</option>
            <option v-for="value in formFields" v-if="value.name.includes('date')" :value="value.name">[{{ value.label }}] {{ value.description }}</option>
          </select>
        </div>
      </div>

      <div v-if="['daterange','daterange-field'].includes(field.formData)" class="col-lg-6 margin-bottom-15">
        <div :class="['form-group', {['has-error']: errors.first(field.name + '-datepicker', fieldData.name)}]">
          <label>Select date range*</label>
          <date-picker
            v-model="field.formDataRange"
            input-class="form-control"
            placeholder="Select Date Range"
            lang="en"
            range-separator="-"
            :format="calendarFormat"
            :value-type="'format'"
            :range="true"
            :confirm="false"
            prefix-class="xmx"
            :data-vv-name="fieldData.name + '-datepicker'"
            v-validate="'required'"
          />
        </div>
      </div>
    </div>

    <div class="form-group" v-if="field.formId">
      <label :for="field.name + '-source-field'">Show fields</label>
      <div class="margin-top-10">
        <template v-for="field in formFields">
          <label class="mt-checkbox mt-checkbox-outline">
            <input type="checkbox" v-model="showFields" :value="field.name"/>
            <span></span>[{{ field.label }}] {{ field.description }}
          </label>
          <br/>
        </template>
      </div>

    </div>

  </form>
</template>

<script>

import {mapGetters} from "vuex";
import DatePicker from 'vue2-datepicker';
import {getUserInfo} from "../../../http-common";

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'FormBuilderSharedFormPreview',
  props: ['fieldData', 'formId'],

  data() {
    return {
      loading: false,
      formFields: [],
      dataRange: [],
      showFields: [],
      field: {},
      isSourceFormRangeSelectVisible: true
    }
  },
  components: {
    DatePicker
  },
  mounted() {
    this.field = this.fieldData;

    if (!this.fieldData.hasOwnProperty('showFields')) {
      this.showFields = [];
    } else {
      this.showFields = this.fieldData.showFields;
    }

    let fieldDefaults = {
      formId: null,
      formData: null,
      showFields: [],
      formDataRange: [],
      dateRangeField: null,
      readOnly: false
    };

    for (const [property, value] of Object.entries(fieldDefaults)) {
      if (!this.field.hasOwnProperty(property)) {
        this.$set(this.field, property, value);
      }
    }

    if (this.field.formId) {
      this.updateFormFields(null, false);
    }
  },
  computed: {
    ...mapGetters({
      'forms': 'getFormsWithSharedFieldsAlphabetical',
      'systemForms': 'getSystemForms'
    }),
    calendarFormat() {
      return getUserInfo('date_format');
    },
    systemFormIds() {
      const systemFormIds = [];

      for (const systemForm in this.systemForms) {
        systemFormIds.push(this.systemForms[systemForm].id)
      }

      return systemFormIds;
    }
  },
  methods: {
    updateFormFields(_event, shouldResetFormDataSelect = true) {
      let formFields = this.forms.find(item => item.id === this.field.formId);
      if (formFields) {
        this.formFields = formFields.sharedFields;
      }

      // set formData to 'last' and hide this select when formId is any system form
      if (this.systemFormIds.includes(this.field.formId)) {
        this.isSourceFormRangeSelectVisible = false
        this.field.formData = 'last'
      } else if (shouldResetFormDataSelect) {
        this.isSourceFormRangeSelectVisible = true
        this.field.formData = null
      }
    },
  },
  watch: {
    showFields: function (newVal) {
      this.field.showFields = newVal;
    },
    field: {
      deep: true,
      handler: function () {
        this.updateFormFields(null, false);
        this.$emit('update', this.field);
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// FormBuilderSharedFormPreview.vue?55810658